import React, { useState } from "react";
import classes from "./Profile.module.css"
import profileIn from "../../../img/profileIn.png"
import { Link } from "react-router-dom";
import Login from "./Login/Login";

const Profile = () => {


    return (
        <div className={classes.Profile}>
            <div className={classes.contentProfile}>
                <Login></Login>
            </div>
        </div>
    )
}

export default Profile